import { CoreScoreNames } from '../../../common/enum/scores/core-score-name.enum';
import { CubeRequestConfig } from '../../../common/interface/cube-request-config.interface';

export interface GetSelfScoreAveragesSummaryRequestDto {
  params: {
    endDate: string;
    score: CoreScoreNames;
  };
  config: CubeRequestConfig;
}
